"use client";

import { CcSeoProcess } from "@/components/services/seo/CcSeoProcess";
import type { SeoPageCopy } from "@/components/services/seo/seo-page-copy";

import { LEAD_PROCESS_ILLUSTRATIONS } from "./lead-process-illustrations";

/**
 * The process section with the lead generation drawings. A client wrapper,
 * because drawing components can't be passed as props from the server view.
 */
export function CcLeadProcess({ copy }: { copy: SeoPageCopy["process"] }) {
  return <CcSeoProcess copy={copy} illustrations={LEAD_PROCESS_ILLUSTRATIONS} />;
}
